export const DEFAULT_VOXELS_PER_CM = 2
export const USE_DEVICE_PIXEL_RATIO_FOR_CM = false
export const INITIAL_BOUNDS_MIN_XZ = 32
export const INITIAL_BOUNDS_MIN_Y = 16
export const INITIAL_BOUNDS_HEIGHT_RATIO = 0.4
